/**
 * Plantilla fija de permisos para clientes (decisión de Juan, 2026-10-06).
 *
 * Es el campo `permissions` COMPLETO de una matriz folders/{cid}/.../users/{uid}
 * de un usuario con rol de cliente: formato granular (documents.granular:true)
 * y TODAS las claves explícitas, igual a lo que guarda hoy el drawer de
 * Permisos (permission_matrix.fieldsToPermissions) con estas casillas, más
 * folders.closing:false (el drawer ya no la muestra, pero matrices viejas la
 * traen y permission_merge todavía la une).
 *
 *  Archivos: Leer, Subir documentos, Subir XML, Vincular documentos, Agregar
 *            referencias, Aprobar, Desaprobar y Descargar. Sin eliminar nada
 *            ni contabilizar.
 *  Carpetas: solo Leer.
 *
 * COPIA en daysi-cloud-functions/scripts/client_template_lib.js (la usa el
 * script que la aplica a las matrices existentes). client_template.test.js
 * exige que sean idénticas: si cambias una, cambia la otra.
 *
 * Módulo puro y sin imports (el test del script lo lee como texto).
 */
export const CLIENT_MATRIX_TEMPLATE = {
  documents: {
    granular: true,
    read: true,
    create: true,
    createXml: true,
    createLink: true,
    createReference: true,
    update: true,
    disapprove: true,
    delete: false,
    deleteXml: false,
    deleteReference: false,
    deleteLinked: false,
    accounting: false,
    deleteAccounting: false,
    download: true,
  },
  folders: {
    read: true,
    create: false,
    update: false,
    delete: false,
    closing: false,
    download: false,
  },
};

/** Copia nueva de la plantilla, para escribirla sin compartir la constante. */
export const clientMatrixPermissions = () => ({
  documents: { ...CLIENT_MATRIX_TEMPLATE.documents },
  folders: { ...CLIENT_MATRIX_TEMPLATE.folders },
});

export default CLIENT_MATRIX_TEMPLATE;
